import {Lang, PersonalityType, ResultMode} from '@context/CompetitionImamrezaContext';
import {useScopedTranslation} from '@hooks/useScopedTranslation';
import scopedI18n from '@locale/scoped-i18n';
import {Box, useTheme} from '@mui/material';
import {loadLang} from '@utils/langStorage';
import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

// Images
import pilgrimage_ar_title from './assets/images/pilgrimage-ar-title.webp';
import pilgrimage_bg from './assets/images/pilgrimage-bg.webp';
import pilgrimage_en_title from './assets/images/pilgrimage-en-title.webp';
import pilgrimage_exit from './assets/images/pilgrimage-exit.webp';
import pilgrimage_fa_title from './assets/images/pilgrimage-fa-title.webp';

import selfKnowledge_ar_title from './assets/images/selfKnowledge-ar-title.webp';
import selfKnowledge_bg from './assets/images/selfKnowledge-bg.webp';
import selfKnowledge_en_title from './assets/images/selfKnowledge-en-title.webp';
import selfKnowledge_exit from './assets/images/selfKnowledge-exit.webp';
import selfKnowledge_fa_title from './assets/images/selfKnowledge-fa-title.webp';

import services_ar_title from './assets/images/services-ar-title.webp';
import services_bg from './assets/images/services-bg.webp';
import services_en_title from './assets/images/services-en-title.webp';
import services_exit from './assets/images/services-exit.webp';
import services_fa_title from './assets/images/services-fa-title.webp';

import {PilgrimageModeContent} from './PilgrimageModeContent';
import {SelfKnowledgeModeContent} from './SelfKnowledgeModeContent';
import {ServicesModeContent} from './ServicesModeContent';

// Title images for each mode and lang
const pilgrimageTitleImage: Record<Lang, string> = {
	en: pilgrimage_en_title,
	fa: pilgrimage_fa_title,
	ar: pilgrimage_ar_title
};

const selfKnowledgeTitleImage: Record<Lang, string> = {
	en: selfKnowledge_en_title,
	fa: selfKnowledge_fa_title,
	ar: selfKnowledge_ar_title
};

const servicesTitleImage: Record<Lang, string> = {
	en: services_en_title,
	fa: services_fa_title,
	ar: services_ar_title
};

type Props = {}

export const ImamrezaServicesMode = (props: Props) => {
	const {mode, type} = useParams<{mode: ResultMode; type: PersonalityType}>();
	const theme = useTheme();
	const {t} = useScopedTranslation();
	const navigate = useNavigate();
	const lang = loadLang();
	useEffect(() => {
		scopedI18n.changeLanguage(lang);
	}, []);
	const backgroundMap: Record<ResultMode, string> = {
		pilgrimage: pilgrimage_bg,
		selfKnowledge: selfKnowledge_bg,
		services: services_bg
	};
	
	const titleMap: Record<ResultMode, Record<Lang, string>> = {
		pilgrimage: pilgrimageTitleImage,
		selfKnowledge: selfKnowledgeTitleImage,
		services: servicesTitleImage
		
	};
	
	const exitMap: Record<ResultMode, string> = {
		pilgrimage: pilgrimage_exit,
		selfKnowledge: selfKnowledge_exit,
		services: services_exit
	};
	
	const backgroundImage = mode ? backgroundMap[mode] : pilgrimage_bg;
	const titleImage = mode ? titleMap[mode][lang] : pilgrimageTitleImage.en;
	const exitImage = mode ? exitMap[mode] : pilgrimage_exit;
	
	const ModeComponentMap: Partial<Record<ResultMode, React.FC<{type: PersonalityType; lang: Lang}>>> = {
		pilgrimage: PilgrimageModeContent,
		selfKnowledge: SelfKnowledgeModeContent,
		services: ServicesModeContent
	};
	
	const SelectedModeComponent = mode ? ModeComponentMap[mode] : null;
	
	return (
		<Box
			className="w-full h-screen overflow-hidden justify-start overflow-y-auto pb-20 relative"
			sx={{
				backgroundImage: `url(${backgroundImage})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover'
			}}
		>
			<div className="flex flex-row w-full h-fit justify-center items-center gap-x-3 fixed">
				<img className="w-10/12" src={titleImage} alt="title"/>
				<img
					className={`w-1/12 h-1/12 absolute top-1/12 cursor-pointer ${lang == 'en' ? 'right-[10%]' : 'left-[12%]'}`}
					src={exitImage}
					alt="exit"
					onClick={() => navigate(-1)}
				/>
			</div>
			
			<div className="flex flex-col justify-start mt-24">
				{SelectedModeComponent && type && <SelectedModeComponent type={type} lang={lang}/>}
			</div>
		</Box>
	);
};
